import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	CanActivate,
	Router,
} from '@angular/router';
import { map, Observable, of, tap } from 'rxjs';

// --- Facades ---
import { AuthFacade } from '@facades/auth.facade';

@Injectable({
	providedIn: 'root',
})
export class VisitorGuard implements CanActivate {
	private readonly isAuthenticated$ = this.authFacade.authState$.pipe(
		map(({ isAuthenticated }) => isAuthenticated)
	);

	constructor(private _router: Router, private authFacade: AuthFacade) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const parameters = JSON.parse(localStorage.getItem('parameters') || '{}');
		const allowGuestUser = parameters.allowGuestUser === true;

		if (!allowGuestUser) {
			this._router.navigate(['/auth']);
			return of(false);
		}

		return (this.isAuthenticated$ as Observable<boolean>).pipe(
			map(isAuthenticated => {
				if (isAuthenticated) {
					this._router.navigate(['/home']);
					return false;
				}

				return true;
			})
		);
	}
}
